import {
    Box,
    Card as MuiCard,
    CardContent as MuiCardContent, CardHeader,
    Grid,
    Theme,
    Typography,
    withStyles
} from "@material-ui/core";
import React, {FC, useEffect, useState} from "react";
import styled from "styled-components/macro";
import {spacing} from "@material-ui/system";
import DoughnutChart from "../../../../../components/DoughnutChart";
import SimpleTable from "./SimpleTable";
import {Clp} from "../../../../../models/Clp";
import NoDataAvailable from "../../../statistic/components/widgets/components/NoDataAvailable";

const Card = styled(MuiCard)(spacing);
const CardContent = withStyles((theme: Theme) => ({
    root: {
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            alignItems: "flex-start",
            flexDirection: "column"
        },
        padding: "0 !important"
    }
}))(MuiCardContent);

type PropsType = {
    data: Clp[] | null
}

const CountMandatoryWidget: FC<PropsType> = ({ data }) => {
    const [calculatedData, setCalculatedData] = useState<any[]>([
        {name: 'Mandatory', value: 0},
        {name: 'Recommended', value: 0}
    ])

    useEffect(() => {
        if (data && data.length > 0) {
            const preparedData = []
            const mandatory = data.filter((i) => i.is_mandatory)
            const recommended = data.filter((i) => !i.is_mandatory)
            if (mandatory.length > 0) {
                preparedData.push({name: 'Mandatory', value: mandatory.length})
            }
            if (recommended.length > 0) {
                preparedData.push({name: 'Recommended', value: recommended.length})
            }
            setCalculatedData(preparedData)
        }
    }, [data]);



    return (
        <Card style={{position: 'relative'}}>
            <CardHeader title={'Issues progress'}/>
            <CardContent>
                <Box display={'flex'} flexDirection={'column'} width={'100%'} >
                    <Box display={'flex'} justifyContent={'center'} flexDirection={'column'} alignItems={'center'} width={'100%'}>
                        <Box mb={3} height={'200px'}>
                            <DoughnutChart
                                labels={calculatedData.map((i) => i.name)}
                                data={calculatedData.map((i) => i.value)}
                            />
                        </Box>
                        <SimpleTable
                            headNames={['Name', 'Value']}
                            rows={calculatedData.map((i) => ({...i, value: `${i.value}`}))}
                        />
                    </Box>
                </Box>
                <NoDataAvailable visible={!!(data && data.length === 0)}/>
            </CardContent>
        </Card>
    )
}

export default CountMandatoryWidget